import { Card, Row, Col, Statistic, Badge } from "antd";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import classes from "./operational.module.scss";
import { Typography } from "antd";
const { Title, Text } = Typography;

const Compliance = () => {
  // Dummy KPIs
  const complianceKpis = [
    { title: "Compliance Health", value: "Excellent", status: "success" },
    { title: "Regulatory Risk Level", value: "Low", status: "processing" },
    { title: "Policy Update Status", value: "82%", suffix: "" },
  ];

  // Dummy Compliance Trend Chart
  const complianceTrendChart = {
    chart: { type: "line" },
    title: { text: "Compliance Status Over Time" },
    xAxis: { categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"] },
    yAxis: { title: { text: "Compliance Score (%)" } },
    series: [
      {
        name: "Compliance Score",
        data: [60, 70, 75, 80, 85, 90],
      },
    ],
  };

  return (
    <>
      {" "}
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0 }}>
          Compliance System
        </Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Show risk/legal/compliance status of the company and its vendors.
        </Text>
      </div>
      <div style={{ padding: "20px" }}>
        {/* KPI Cards */}
        <Row gutter={[16, 16]}>
          {complianceKpis.map((kpi, index) => (
            <Col span={8} key={index}>
              <Card>
                {kpi.status ? (
                  <>
                    <Statistic
                      title={kpi.title}
                      valueRender={() => (
                        <span>
                          <Badge
                            status={kpi.status}
                            style={{ marginRight: 8 }}
                          />
                          {kpi.value}
                        </span>
                      )}
                    />
                  </>
                ) : (
                  <Statistic
                    title={kpi.title}
                    value={kpi.value}
                    suffix={kpi.suffix || ""}
                  />
                )}
              </Card>
            </Col>
          ))}
        </Row>

        {/* Compliance Trend Chart */}
        <Row style={{ marginTop: 30 }}>
          <Col span={24}>
            <Card title="Compliance Trend">
              <HighchartsReact
                highcharts={Highcharts}
                options={complianceTrendChart}
              />
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default Compliance;
